class NotificationController {
  constructor() {
    this.ref = null;
  }

  initialize(ref) {
      this.ref = ref;
  }

  addNotification(notification) {
    this.ref.addNotification(notification);
  }
}

export default NotificationController;


// WEBPACK FOOTER //
// ./src/NotificationController.js